import axiosInstance from "../utils/axios";

const BASE_URL = "/projects/v1";
const BASKETS_URL = "/projects/baskets/v2";

async function getBasketById(id: string) {
  return axiosInstance.get(`${BASE_URL}/baskets/${id}`, {});
}

function getBasketByCodeApi(codes: string[]) {
  const params: { codes?: string[] } = {};

  if (codes) {
    params.codes = codes;
  }

  return axiosInstance.get(BASKETS_URL, {
    params,
    paramsSerializer: {
      serialize: (params) => {
        return `${
          codes
            ? params.codes.map((c: string) => `codes=${c}`).join("&")
            : ""
        }`;
      },
    },
  });
}

export { getBasketById, getBasketByCodeApi };
